import axios from "../axiosApi";
import { FETCH_TEACHERS, RECEIVE_TEACHERS, SAVE_TEACHER, SAVE_TEACHER_SUCCESS, DELETE_TEACHER, DELETE_TEACHER_SUCCESS } from "../actionTypes";

export const getTeachers = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_TEACHERS });
        try {
            const filter = JSON.stringify({ include: ["fermiUser"] });
            const response = await axios.get(`/Teachers?filter=${filter}`);
            dispatch({ type: RECEIVE_TEACHERS, payload: response.data });
        } catch (e) {
            console.error("getTeachers ERROR", e);
            dispatch({ type: RECEIVE_TEACHERS, payload: [] });
        }
    }
}

export const saveTeacher = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_TEACHER });
        try {
            let response;
            if (data.id) {
                const id = data.id;
                delete data.id;
                response = await axios.patch(`/Teachers/${id}`, data);
            } else {
                if (data.id === null) delete data.id;
                response = await axios.post('/Teachers', data);
            }
            dispatch({ type: SAVE_TEACHER_SUCCESS, payload: response.data });
            dispatch(getTeachers());
        } catch (e) {
            console.error("saveTeacher ERROR", e);
            dispatch({ type: SAVE_TEACHER_SUCCESS, payload: { error: true } });
        }
    }
}

export const deleteTeacher = (id: number) => {
    return async (dispatch: any) => {
        dispatch({ type: DELETE_TEACHER });
        try {
            await axios.delete(`/Teachers/${id}`);
            dispatch({ type: DELETE_TEACHER_SUCCESS });
            dispatch(getTeachers());
        } catch (e) {
            console.error("deleteTeacher ERROR", e);
        }
    }
}
